<script>
    import ProjectField from "../../models/participaid/ProjectField.js";

    export let past = true;

    export let name;
    export let companyName;
    export let companySharePercentage;
    export let companySharePrice;
    export let companyValuation;
    export let visibilityTeam;
    export let endDate;
    export let administrationPeriodType;
    export let stockCalculationStrategy;
    export let fields;

    export let showFields = true;
</script>

<p>
    {#if !past}
        <em>Review your chosen Partipie settings and submit to see your new project.</em>
    {:else}
        <em>Review the Partipie settings</em>
    {/if}
</p>
<p>
    {#if !past}
        When submitting, a <strong>new ParticipAid Partipie</strong> will start titled <strong>'{name}'</strong>
        It will be created for the company <strong>'{companyName}'</strong>.
    {:else}
        Partipie <strong>'{name}'</strong>
        Under the company: <strong>'{companyName}'</strong>
    {/if}
</p>
<p>
    {#if !past}
        Your participants <strong>should {#if !visibilityTeam}not{/if} see each other's contributions</strong>.
    {:else}
        The participants <strong>should {#if !visibilityTeam}not{/if} see each other's contributions</strong>.
    {/if}
</p>
<p>
    Administration spans <strong>{administrationPeriodType.toLowerCase()}</strong> periods.
    The Partipie is aimed to <strong>end around {endDate}</strong>.

<p>
    <strong>{companySharePercentage}% of {companyName}'s stock</strong> (current or to be issued) will be used for rewarding participants' contributions.
    A (virtual) company <strong>share price of €{companySharePrice.toFixed(2)}</strong>,
    at a <strong>company valuation of €{companyValuation.toLocaleString()}</strong> will be used to account for stock distribution among participants.
</p>
<p>
    Stock will be assigned
    {#if stockCalculationStrategy == "DISTRIBUTE_BASED_ON_STOCK_VALUE"}
        <strong>based on the value of contributions</strong>, until the total contribution value of participants collectively exceeds the available company stock value.
        In that case, all available stock will then be divided based on participants' contribution sizes relative to each other.
    {:else}
        <strong>using the fixed percentage of available company stock</strong>.
        All available stock will be divided, regardless of whether the total contribution value reaches the available company stock value.
    {/if}
</p>

{#if showFields}
    {#if fields.length}
        {#if !past}
            The following <strong>{fields.length} fields</strong> will be created:
        {:else}
            The following <strong>{fields.length} fields</strong> were created:
        {/if}

        <ul>
            {#each fields as field}
                <li>
                    <span class="review-field-name">{field.name}</span>
                    <span class="review-field-multiplier">x{field.multiplier}</span>
                    <span class="review-field-input-type">({ProjectField.getFieldInputType(field)})</span>
                </li>
            {/each}
        </ul>
    {:else if !past}
        <strong>No fields</strong> will be created yet.
    {:else}
        <strong>No fields</strong> were created yet.
    {/if}
{/if}